import {useEffect, useState, useContext} from 'react';
import {Modal} from "react-bootstrap";
import Table from "components/Processlog/Table";
import Chart from "components/Processlog/Chart";
import Calendar from "components/Processlog/Calendar";
import SpinnerBootrap from 'components/SpinnerBootrap';
import LogContext from 'context/LogContext';
import './styles.css';
import {
 getOne as getOneProcess
} from "services/ProcesslogService"

import Swal from 'sweetalert2'

const VALUES_RESULTADOS = {
     errors: [],
     warnings: [],
     infos: [],
     alerts: [],
     offs: [],
     rakes: []
}

const VALUES_SWITCH = {
    switch1: true,
    switch2: true,
    switch3: false,
    switch4: false,
    switch5: false,
    switch6: false,
}

function LogOne(){

 const [loading, setLoading] = useState(false);
 const [resultados, setResultados] = useState(VALUES_RESULTADOS)
 const [resultadosFiltrados, setResultadosFiltrados] = useState(VALUES_RESULTADOS);
 const [modalMessageShow, setModalMessageShow] = useState(false);
 const [arrayProcesslog, setArrayProcesslog] = useState([]);
 const [fechasInicial, setFechasInicial] = useState([]);
 const [fechas, setFechas] = useState([])
 const [isErrorsEmpty, setIsErrorsEmpty] = useState(false);
 const [isWarningsEmpty, setIsWarningsEmpty] = useState(false);
 const [isInfosEmpty, setIsInfosEmpty] = useState(false);
 const [isAlertsEmpty, setIsAlertsEmpty] = useState(false);
 const [isOffsEmpty, setIsOffsEmpty] = useState(false);
 const [isRakesEmpty, setIsRakesEmpty] = useState(false);
 const [isProcesslog, setIsProcesslog] = useState(false);
 const [formSwitch, setFormSwitch] = useState(VALUES_SWITCH);

 const [message, setMessage] = useState({
  message: '',
  status: 200
 })
 const {switch1, switch2, switch3, switch4, switch5, switch6} = formSwitch

 const {status} = message;
 const {log} = useContext(LogContext);
 const {_id} = Object.keys(log).length ? log : ({_id: window.location.pathname.split('/')[2]})

 const getOneProcessLog = async ({_id}) => {
     setLoading(true)
     try{
        const {message, body} = await getOneProcess({id: _id, perror: switch1 ? 'on' : '', pwarning: switch2 ? 'on' : '', pinfo: switch3 ? 'on' : '', palert: switch4 ? 'on' : '', poff: switch5 ? 'on' : '', prake: switch6 ? 'on' : ''});
        setResultadosFiltrados(VALUES_RESULTADOS)
        setIsErrorsEmpty(false)
        setIsWarningsEmpty(false)
        setIsInfosEmpty(false)
        setIsAlertsEmpty(false)
        setIsOffsEmpty(false)
        setIsRakesEmpty(false)

        setResultados({
            errors: [...body.errors],
            warnings: [...body.warnings],
            infos: [...body.infos],
            alerts: [...body.alerts],
            offs: [...body.offs],
            rakes: [...body.rakes]
        })
        setFechas([...body.fechas])
        setFechasInicial([...body.fechas])
        setIsProcesslog(true);
        setMessage(state => ({...state, message}))
        Swal.fire(
        'Éxito!!!',
        message,
        'success'
        )
        setLoading(false)
        return ''
     }catch(err){
        const {data, status} = err.response
        setMessage({message: data.message, status})
        setResultados(VALUES_RESULTADOS)
        setIsProcesslog(false);
        setLoading(false)
        return status
     }
 }

 const filtrarFechas = (nuevasFechas) => {
  setLoading(true);
  setFechas([...nuevasFechas]);
  console.log("EJECUTANDO FILTRAR FECHAS")
  let fechasString = nuevasFechas.map(fech => fech.join('/'));
  let errors = resultados.errors.filter(err => fechasString.some(fech => fech === err[0]))
  let warnings = resultados.warnings.filter(war => fechasString.some(fech => fech === war[0]))
  let infos = resultados.infos.filter(inf => fechasString.some(fech => fech === inf[0]))
  let alerts = resultados.alerts.filter(aler => fechasString.some(fech => fech === aler[0]))
  let offs = resultados.offs.filter(off => fechasString.some(fech => fech === off[0]))
  let rakes = resultados.rakes.filter(rak => fechasString.some(fech => fech === rak[0]))
  

  !errors.length ? setIsErrorsEmpty(true) : setIsErrorsEmpty(false);
  !warnings.length ? setIsWarningsEmpty(true) : setIsWarningsEmpty(false);
  !infos.length ? setIsInfosEmpty(true) : setIsInfosEmpty(false);
  !alerts.length ? setIsAlertsEmpty(true): setIsAlertsEmpty(false);
  !offs.length ? setIsOffsEmpty(true) :  setIsOffsEmpty(false);
  !rakes.length ? setIsRakesEmpty(true) : setIsRakesEmpty(false);
  
  let nuevosResultados = {
    errors,
    warnings,
    infos,
    alerts,
    offs,
    rakes 
  }
  setTimeout(() => {
    setResultadosFiltrados({
      ...resultados,
      ...nuevosResultados
    })
    setLoading(false);
  }, 1000)
 }
 
 const resetearFechas = () => {
     filtrarFechas(fechasInicial);
 }
 const handleSwitch = (e) => {

    if(e.target.name === "switch2" && switch1 && !switch3 && !switch4 && !switch5 && !switch6){
        setFormSwitch({
            ...formSwitch,
            [e.target.name]: e.target.checked
        })
    }else if(e.target.name === "switch3" && switch1 && switch2 && !switch4 && !switch5 && !switch6){
         setFormSwitch({
            ...formSwitch,
            [e.target.name]: e.target.checked
        })
    }else if(e.target.name === "switch4" && switch1 && switch2 && switch3 && !switch5 && !switch6){
         setFormSwitch({
            ...formSwitch,
            [e.target.name]: e.target.checked
        })
    }else if(e.target.name === "switch5" && switch1 && switch2 && switch3 && switch4 && !switch6){
         setFormSwitch({
            ...formSwitch,
            [e.target.name]: e.target.checked
        })
    }else if(e.target.name === "switch6" && switch1 && switch2 && switch3 && switch4 && switch5){
         setFormSwitch({
            ...formSwitch,
            [e.target.name]: e.target.checked
        })
    }
 }


 useEffect(() => {
    if(status !== 401 ) return
    localStorage.removeItem('token');
    window.location.href="/login";
 }, [status])

 useEffect(() => {
  
  (async () => {
   await getOneProcessLog({_id});
  })()
  // eslint-disable-next-line
 }, [])
 return (
 <div className="container">
     <div className="row my-md-4">
         <h3 className="d-flex justify-content-center text-uppercase">Procesamiento del Log</h3>

         <div className="col-12">
            <div className="row justify-contente-center align-items-center">
                <div className="col-12">
                    <h5>Parámetros de Procesamiento</h5>
                    <p><small>Elige los parámetros que quieras Procesar!!!</small></p>
                    <ul className="list-group">
                        <li className="list-group-item d-flex justify-content-between">Error <input type="checkbox" id="switch1" name="switch1" checked={switch1} onChange={handleSwitch}/><label for="switch1">Toggle</label></li>
                        <li className="list-group-item d-flex justify-content-between">Warning <input type="checkbox" id="switch2" name="switch2" checked={switch2} onChange={handleSwitch}/><label for="switch2">Toggle</label></li>
                        <li className="list-group-item d-flex justify-content-between">Info <input type="checkbox" id="switch3" name="switch3" checked={switch3} onChange={handleSwitch}/><label for="switch3">Toggle</label></li>
                        <li className="list-group-item d-flex justify-content-between">Alert <input type="checkbox" id="switch4" name="switch4" checked={switch4} onChange={handleSwitch}/><label for="switch4">Toggle</label></li>
                        <li className="list-group-item d-flex justify-content-between">Off <input type="checkbox" id="switch5" name="switch5" checked={switch5} onChange={handleSwitch}/><label for="switch5">Toggle</label></li>
                        <li className="list-group-item d-flex justify-content-between">Rake <input type="checkbox" id="switch6" name="switch6" checked={switch6} onChange={handleSwitch}/><label for="switch6">Toggle</label></li>
                    </ul>
                </div>
                <div className="col-12 themed-grid-col ms-2 d-flex justify-content-center align-items-center" >
                    <button className={'my-3 btn btn-lg btn-info'} type="submit"
                            onClick={() => getOneProcessLog({_id})}><i
                        className="bi bi-save"/>Procesar</button>
                </div>
            </div>
         </div>

         <div className="col-12">
            {loading 
             ?                 
             <SpinnerBootrap/>
             :
                
                isProcesslog 
                ?
                (resultados.errors.length || resultados.warnings.length || resultados.infos.length || resultados.alerts.length || resultados.offs.length || resultados.rakes.length) ? 
                <>
                    <Calendar fechas={fechas} filtrarFechas={filtrarFechas} resetearFechas={resetearFechas} fechasInicial={fechasInicial} isConsolidado={false}></Calendar> : ''
                    
                    <h4>RESULTADOS</h4>
                    <Chart 
                    errors={resultados.errors} 
                    warnings={resultados.warnings} 
                    infos={resultados.infos} 
                    alerts={resultados.alerts} 
                    offs={resultados.offs} 
                    rakes={resultados.rakes} 

                    errorsF={resultadosFiltrados.errors} 
                    warningsF={resultadosFiltrados.warnings} 
                    infosF={resultadosFiltrados.infos} 
                    alertsF={resultadosFiltrados.alerts} 
                    offsF={resultadosFiltrados.offs} 
                    rakesF={resultadosFiltrados.rakes} 
                    
                    isErrorsEmpty={isErrorsEmpty}
                    isWarningsEmpty={isWarningsEmpty}
                    isInfosEmpty={isInfosEmpty}
                    isAlertsEmpty={isAlertsEmpty}
                    isOffsEmpty={isOffsEmpty}
                    isRakesEmpty={isRakesEmpty}

                    ></Chart>

                    <Table 
                    datos={resultados.errors} 
                    datosF={resultadosFiltrados.errors} 
                    titulo={"TOP ERRORS"} 
                    setModalMessageShow={setModalMessageShow}
                    setArrayProcesslog={setArrayProcesslog}
                    isEmpty={isErrorsEmpty}
                    />
                    <Table 
                    datos={resultados.warnings} 
                    datosF={resultadosFiltrados.warnings} 
                    titulo={"TOP WARNINGS"} 
                    setModalMessageShow={setModalMessageShow}
                    setArrayProcesslog={setArrayProcesslog}
                    isEmpty={isWarningsEmpty}  
                    />
                </>
                : 
                <h4 className="my-4" style={{"color": "red"}}>No se encontraron resultados</h4>
                :
                ''
            }


            <Modal
                show={modalMessageShow}
                onHide={() => setModalMessageShow(false)}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                    Mensaje del Proceso
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{"overflow": "auto"}}>
                    <small>{arrayProcesslog.length && arrayProcesslog[3]}</small>
                </Modal.Body>    
            </Modal>

         </div> 
     </div>
 </div>
 )
}

export default LogOne